<template>
  <PanelHeader :panel-index="panelIndex">
    <template #menu>
      <PanelHeaderMenu :panel-index="panelIndex" />
    </template>

    <h2 class="panel-title-wrapper can-truncate">
      <span class="panel-title">My Account</span>
    </h2>
  </PanelHeader>

  <div class="content-wrapper">
    <div class="scroll-content" data-panel="scroll-content account-settings">
      <UserIcon :color="user?.avatar_color" size="xlarge" data-avatar="image" />
      <form
        ref="nameForm"
        data-testid="name-form"
        data-form="autosave account-settings"
        @submit.prevent="saveName"
      >
        <AccountFieldName
          v-model="formName"
          :disabled="!connected"
          @focusout="saveName"
        />
        <UtilitySaveIndicator :state="savingName" />
      </form>
      <AccountFormPasswordChange :disabled="!connected" />
      <AccountFormTheme :disabled="!connected" />
      <AccountFormFont :disabled="!connected" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';

import AccountFieldName from '@/js/components/account/field-name.vue';
import AccountFormFont from '@/js/components/account/form-font.vue';
import AccountFormPasswordChange from '@/js/components/account/form-password-change.vue';
import AccountFormTheme from '@/js/components/account/form-theme.vue';
import UserIcon from '@/js/components/icons/user-icon.vue';
import PanelHeader from '@/js/components/panels/header.vue';
import PanelHeaderMenu from '@/js/components/panels/header-menu.vue';
import useFormFieldAutoSave from '@/js/composables/useFormFieldAutoSave';
import { useSocketStore } from '@/js/stores/socket';
import { useUserStore } from '@/js/stores/user';

export default defineComponent({
  name: 'PanelMyAccount',
  components: {
    AccountFormPasswordChange,
    AccountFieldName,
    AccountFormFont,
    AccountFormTheme,
    PanelHeader,
    PanelHeaderMenu,
    UserIcon,
  },
  props: {
    panelIndex: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const userStore = useUserStore();
    const socketStore = useSocketStore();
    const connected = computed(() => socketStore.connected);
    const user = computed(() => userStore.user);

    // Name form
    const username = computed(() => user.value?.name ?? '');
    const nameForm = ref<HTMLFormElement | null>(null);
    const updateName = (name: string) => userStore.update({ name });
    const {
      update: saveName,
      formValue: formName,
      saving: savingName,
    } = useFormFieldAutoSave({
      value: username,
      form: nameForm,
      save: updateName,
      debounce: 3000,
    });

    return {
      connected,
      saveName,
      formName,
      nameForm,
      savingName,
      user,
    };
  },
});
</script>
